/**
 * @generated SignedSource<<7ca9005ce0d9353455a3d49ad261a68b>>
 * @relayHash f9ff7da6eb9076404db41ced3abf8d59
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9ff7da6eb9076404db41ced3abf8d59

import type { ConcreteRequest } from 'relay-runtime';
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type IssueMultiSelectFieldPickerFieldQuery$variables = {
  id: string;
};
export type IssueMultiSelectFieldPickerFieldQuery$data = {
  readonly node: {
    readonly options?: ReadonlyArray<{
      readonly color: IssueFieldSingleSelectOptionColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
    }>;
  } | null | undefined;
};
export type IssueMultiSelectFieldPickerFieldQuery = {
  response: IssueMultiSelectFieldPickerFieldQuery$data;
  variables: IssueMultiSelectFieldPickerFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueFieldSingleSelectOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueMultiSelectFieldPickerFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "IssueMultiSelectFieldPickerFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f9ff7da6eb9076404db41ced3abf8d59",
    "metadata": {},
    "name": "IssueMultiSelectFieldPickerFieldQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "557e6dd5b4e8df708b6737899fb53bde";

export default node;
